export const environment = {
    clientId: '985d3eb5-fb9a-4cde-870b-84c111a6ddb1',
    redirectUrl: 'https://matrisneo.purapi.devtest.aws.scania.com',
    authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
    baseUrl: 'https://sgx2qbjctg.execute-api.eu-west-1.amazonaws.com/dev',
    xApiKey: 'qF1CaXdvioEk1FRboZCt9Wt87F9ExHq3Ca8j7WZd',
    tokenUrl: 'https://2svxxz0yy9.execute-api.eu-west-1.amazonaws.com/dev/token',
    version: '1.0.6',
    scopes: ['api://73e92719-a258-4ccf-a6d5-86282cd6f055/user_access'],
    production: false,
    favicon: './assets/DEV_resized-removebg-preview.png',
    menubar: '#0d0d0d',
    hover: '#004851', // Menubar Hover
    footer: '#0d0d0d'
}